export const messageTextClasses =
  "text-sm font-normal whitespace-pre-line chat-message-word-wrap text-darkest";
